import React from 'react'
import Container from './container'
import Logo from './logo'
import DemoButton from './demo_button'
import styles from './header.module.css'

const siteUrl = 'https://www.wagetap.com/?referrer=blog';

export default (props) => (
  <div className={styles.headerWrapper}>
    <Container>
      <header className={styles.header}>
        <Logo/>
        <Navigation/>
      </header>
    </Container>
  </div>
);

const Navigation = () => (
  <nav role="navigation">
    <ul className={styles.navigation}>
      <li className={styles.navigationItem + " hideOnMobile"}>
        <a href={siteUrl} className={styles.navLink}>Home</a>
      </li>
      <li className={styles.navigationItem + " hideOnMobile"}>
        <DemoButton />
      </li>
    </ul>
  </nav>
)
